import { useSelector } from "react-redux";
import { IUser } from "../../models/user";
import { hasFullMenu, resolveRole } from "../../services/roles";
import DevicesHubsPage from "./devices.hubs";
import DevicesList from "./devices.list";
import { useI18n } from "../../i18n/I18nContext";

const DevicesPage = () => {
  const { t } = useI18n();
  const user = useSelector(({ UserSlice }: any) => UserSlice.user as IUser);
  const role = resolveRole(user?.role);

  // admin — плоский инженерный список; manager/operator — Hub → ASI
  if (hasFullMenu(role)) {
    return (
      <div>
        <h2 style={{ marginBottom: 16 }}>{t("app.devices")}</h2>
        <DevicesList />
      </div>
    );
  }

  return <DevicesHubsPage />;
};

export default DevicesPage;
